export default "__VITE_ASSET__CS6Yyj0D__"